import { Option } from '@de/types/types';

export interface ParsedQueryParam {
  key: string;
  customField: string;
}

// Handles both "paramName=customField" and "customField" formats
export const extractCustomFieldFromQueryParam = (
  param: string,
): ParsedQueryParam => {
  const parts = param.split('=');

  if (parts.length === 2) {
    // Format: "paramName=customField"
    const key = parts[0].trim();
    const customField = parts[1].trim().replace(/[^a-zA-Z]/g, '');
    return { key, customField };
  }

  // Format: "customField" (use as both key and customField)
  const customField = param.trim();
  return { key: customField, customField };
};

// Extracts the value(s) from an Option or array of Options as a string.
export const getOptionValueString = (
  option: Option | Option[] | null | undefined,
): string | null => {
  if (!option) {
    return null;
  }

  if (Array.isArray(option)) {
    return option.map((opt) => opt.value ?? opt.text).join(',');
  }

  return (option.value ?? option.text ?? '') as string;
};
